/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ScaledImagesControllerGetImageDataByIdAndFilename$Params {
  id: string;
  scale: number;
}

export function scaledImagesControllerGetImageDataByIdAndFilename(http: HttpClient, rootUrl: string, params: ScaledImagesControllerGetImageDataByIdAndFilename$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, scaledImagesControllerGetImageDataByIdAndFilename.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('scale', params.scale, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

scaledImagesControllerGetImageDataByIdAndFilename.PATH = '/scaled-images/get-image/{scale}/{id}/{fileName}';
